import { render, staticRenderFns } from "./FormAudioInputElement.vue?vue&type=template&id=5dc8b3f6&scoped=true"
import script from "./FormAudioInputElement.vue?vue&type=script&lang=js"
export * from "./FormAudioInputElement.vue?vue&type=script&lang=js"
import style0 from "./FormAudioInputElement.vue?vue&type=style&index=0&id=5dc8b3f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc8b3f6",
  null
  
)

export default component.exports